import { VAlert } from 'vuetify/lib/components/VAlert';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"justify-center":"","align-center":""}},[_c(VAlert,{staticClass:"alert",attrs:{"type":_vm.alert.type,"dismissible":_vm.alert.dismissible,"transition":"scale-transition"},model:{value:(_vm.alert.show),callback:function ($$v) {_vm.$set(_vm.alert, "show", $$v)},expression:"alert.show"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.alert.text)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }